import React, {Suspense} from "react";
import ReactDOM from "react-dom/client";
import {store} from "@/store/store";
import {Provider} from "react-redux";
import "bootstrap";
import "@/styles/main.scss";

import ForthRoute from "@/routers/ForthRoute";

import {ThemeProvider} from "@/contexts/ThemeContext";
import {handleManifest} from "./helpers/handleManifest.js";
import {checkMaintenanceMode} from "./helpers/checkMaintenanceMode.js";
import {checkClearCache} from "./helpers/checkClearCache.js";
import {clearCache} from "./helpers/clearCache.js";
import MaintenancePage from "@/components/Global/MaintenancePage/MaintenancePage";
import Loader from "@/components/Global/Loader/Loader";
import {config} from "./config";

handleManifest();

const {websiteId} = config;
const isForth = websiteId === 1;
const isEdge = websiteId === 2;
const isBiomarkerTracking = websiteId === 3;

const edgeStyle = {"--loader-bg-color": "#000000", color: "#ffffff", "--font-color": "#ffffff"};
const biomarkerTrackingStyle = {
  "--loader-bg-color": "var(--bg-app, #ffffff)",
  "--font-color": "#000000",
  color: "#000000",
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Loader variant="fullWindow" style={isForth ? {} : isEdge ? edgeStyle : biomarkerTrackingStyle} />);
const isOnline = window?.navigator?.onLine || false;

let isMaintenanceModeActive = true;
if (isOnline) {
  isMaintenanceModeActive = await checkMaintenanceMode();
}

let needToClearCache = false;
let clearOptions = {};
if (isOnline) {
  const response = await checkClearCache();

  if (response.needToClearCache) {
    needToClearCache = response.needToClearCache;
    clearOptions = {
      clearCache: response.clearCache,
      clearBrowserStorage: response.clearBrowserStorage,
      clearCookies: response.clearCookies,
      clearGlobalState: response.clearGlobalState,
    };
  } else {
    needToClearCache = false;
  }
}

const location = window.location.pathname;
const isAuth = localStorage.getItem("token");
let renderApp = true;

if (isAuth && ["/demo", "/fhmdemo"].includes(location)) {
  renderApp = false;
  const response = await clearCache({
    clearBrowserStorage: true,
    clearGlobalState: true,
    clearCache: true,
    clearCookies: true,
  });

  if (response === true) {
    window.location.replace(location);
  }
}

if (!isMaintenanceModeActive && needToClearCache) {
  renderApp = false;
  const response = await clearCache(clearOptions);

  if (response === true) {
    const needRefresh = new URLSearchParams(window.location.search).get("refresh") == "true";
    if (needRefresh) {
      window.location.replace(location);
    } else {
      renderApp = true;
    }
  }
} else {
  localStorage.removeItem("loadedNewStorage");
}

if (renderApp && isMaintenanceModeActive) {
  root.render(<MaintenancePage />);
} else if (renderApp) {
  root.render(
    <Suspense fallback={<Loader variant="fullWindow" />}>
      <Provider store={store}>
        <ThemeProvider>
          <ForthRoute />
        </ThemeProvider>
      </Provider>
    </Suspense>,
  );
}
